<template>
  <div style="width: 1800px;">
    <canvas
      v-show="lineChartShow && currPlay!=='wxzh'"
      ref="trendCanvas"
      :width="canvas.width"
      :height="canvas.height"
      class="trend-canvas"
    ></canvas>
    <table ref="trendTable" class="chart-table" style='border-collapse:collapse'>
      <thead ref="Head">
      <template v-if="currPlay === 'wx'">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th ref="rectWidth" colspan="12" class="border-right">万位</th>
          <th colspan="12" class="border-right">千位</th>
          <th colspan="12" class="border-right">百位</th>
          <th colspan="12" class="border-right">十位</th>
          <th colspan="12" class="border-right">个位</th>
          <th colspan="12" class="border-right">号码分布</th>
        </tr>
        <tr class="title-number">
          <template v-for="i in 6">
          <th class="ball-none border-bottom-header" :key="i + 'left'"></th>
          <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num' + i + 'center'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th :key="i + 'right'" class="ball-none border-bottom-header border-right"></th>
          </template>
        </tr>
      </template>
      <template v-if="currPlay === 'wxzh'">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th colspan="12" class="border-right">号码分布</th>
          <th colspan="12" class="border-right">号码跨度</th>
          <th colspan="14" class="border-right">大小比</th>
          <th colspan="14" class="border-right">单双比</th>
          <th colspan="14" class="border-right">质合比</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">和值</th>
        </tr>
        <tr class="title-number">
          <template v-for="i in 2">
            <th class="ball-none border-bottom-header" :key="i + 'left'"></th>
            <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num' + i + 'center'">
              <i class="ball-noraml">{{ num }}</i>
            </th>
            <th :key="i + 'right'" class="ball-none border-bottom-header border-right"></th>
          </template>
          <template v-for="i in 3">
          <th class="ball-none border-bottom-header" :key="i + 'left1'"></th>
          <th colspan="2" class="border-bottom-header" v-for="(numstatus, thnindex) in lotteryNumStatusHead" :key="thnindex + 'num' + i + 'center2'">
            <i class="ball-noraml">{{ numstatus }}</i>
          </th>
          <th :key="i + 'right3'" class="ball-none border-bottom-header border-right"></th>
          </template>
        </tr>
      </template>
      <template v-if="currPlay === 'sx'">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th ref="sxRectWidth1" colspan="12" class="border-right">千位</th>
          <th ref="sxRectWidth2" colspan="12" class="border-right">百位</th>
          <th ref="sxRectWidth3" colspan="12" class="border-right">十位</th>
          <th colspan="12" class="border-right">个位</th>
          <th colspan="12" class="border-right">号码分布</th>
        </tr>
        <tr class="title-number">
          <template v-for="i in 5">
          <th class="ball-none border-bottom-header" :key="i + 'left'"></th>
          <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num' + i + 'center'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th :key="i + 'right'" class="ball-none border-bottom-header border-right"></th>
          </template>
        </tr>
      </template>
      <template v-if="currPlay === 'qs' || currPlay === 'zs' || currPlay === 'hs'">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th id="wanWidth" colspan="12" class="border-right" v-if="currPlay === 'qs'">万位</th>
          <th colspan="12" class="border-right" v-if="currPlay !== 'hs'">千位</th>
          <th ref="rectWidth" colspan="12" class="border-right">百位</th>
          <th colspan="12" class="border-right" v-if="currPlay === 'zs' || currPlay === 'hs'">十位</th>
          <th colspan="12" class="border-right" v-if="currPlay === 'hs'">个位</th>
          <th colspan="12" class="border-right">号码分布</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">大小形态</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">单双形态</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">质合形态</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">012形态</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">组三</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">组六</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">豹子</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">跨度</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">直选和值</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">和值尾数</th>
        </tr>
        <tr class="title-number">
          <template v-for="i in 4">
          <th class="ball-none border-bottom-header" :key="i + 'left'"></th>
          <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num' + i + 'center'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th :key="i + 'right'" class="ball-none border-bottom-header border-right"></th>
          </template>
        </tr>
      </template>
      <template v-if="currPlay === 'qe' || currPlay === 'he'">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th ref="rectWidth" colspan="12" class="border-right" v-if="currPlay === 'qe'">万位</th>
          <th colspan="12" class="border-right" v-if="currPlay === 'qe'">千位</th>
          <th ref="rectWidth" colspan="12" class="border-right" v-if="currPlay === 'he'">十位</th>
          <th colspan="12" class="border-right" v-if="currPlay === 'he'">个位</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">对子</th>
          <th colspan="12" class="border-right">号码分布</th>
          <th colspan="12" class="border-right">跨度走势</th>
          <th rowspan="2" colspan="3" class="border-bottom border-right">和值</th>
        </tr>
        <tr class="title-number">
          <template v-for="i in 4">
          <th class="ball-none border-bottom-header" :key="i + 'left'"></th>
          <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num' + i + 'center'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th :key="i + 'right'" class="ball-none border-bottom-header border-right"></th>
          </template>
        </tr>
      </template>
      </thead>
      <tbody>
        <template v-if="currPlay === 'wx'">
         <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 号码走势 -->
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none" :key="entindex + 'left'"></td>
            <td class="df-trendchart-ssc-tdsize" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <!-- 号码分布 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in opendNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
         </tr>
        </template>
        <template v-if="currPlay === 'wxzh'">
        <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 号码分布 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in opendNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 号码跨度 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'kuaduTableList'" v-for="(num, ontindex) in kuaduTableList[index]">
            <i class="ball-noraml openNo-2" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>  
          <!-- 大小比 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td colspan="2" class="ball-none" :class="{'_bili':num === 'A','border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'dxbTableList'" v-for="(num, ontindex) in dxbTableList[index]">
            <i class="ball-noraml" v-if="num === 'A'">{{ lotteryNumStatusHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 单双比 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td colspan="2" class="ball-none" :class="{'_bili':num === 'A','border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'dsbTableList'" v-for="(num, ontindex) in dsbTableList[index]">
            <i class="ball-noraml" v-if="num === 'A'">{{ lotteryNumStatusHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 质合比 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td colspan="2" class="ball-none" :class="{'_bili':num === 'A','border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'zhbTableList'" v-for="(num, ontindex) in zhbTableList[index]">
            <i class="ball-noraml" v-if="num === 'A'">{{ lotteryNumStatusHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 和值 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml">{{ lotteryTrendTotalArr[index] }}</i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
         </tr>
        </template>
        <template v-if="currPlay === 'sx'">
         <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 号码走势 -->
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList" v-if="entindex > 0">
            <td class="df-trendchart-ssc-tdsize ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'left'"></td>
            <td id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <!-- 号码分布 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in sxOpenNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
         </tr>
        </template>
        <template v-if="currPlay === 'qs' || currPlay === 'zs' || currPlay === 'hs'">
         <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 号码走势 -->
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList" v-if="currPlay === 'qs'&&entindex < 3">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none" :key="entindex + 'left'"></td>
            <td class="df-trendchart-ssc-tdsize" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList" v-if="currPlay === 'zs'&&entindex > 0&&entindex < 4">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none" :key="entindex + 'left'"></td>
            <td class="df-trendchart-ssc-tdsize" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList" v-if="currPlay === 'hs'&&entindex > 1">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none" :key="entindex + 'left'"></td>
            <td class="df-trendchart-ssc-tdsize" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <!-- 号码分布 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td v-if="currPlay === 'qs'" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in qsOpenNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td v-if="currPlay === 'zs'" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in zsOpenNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td v-if="currPlay === 'hs'" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in hsOpenNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <template v-if="currPlay === 'qs'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{ Number(qsOpenNumArr[index][0]) >= 5 ? '大' : '小' }}{{ Number(qsOpenNumArr[index][1]) >= 5 ? '大' : '小' }}{{ Number(qsOpenNumArr[index][2]) >= 5 ? '大' : '小' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_green border-right">
              <i class="ball-noraml">{{ Number(qsOpenNumArr[index][0]) % 2 == 0 ? '双' : '单' }}{{ Number(qsOpenNumArr[index][1]) % 2 == 0 ? '双' : '单' }}{{ Number(qsOpenNumArr[index][2]) % 2 == 0 ? '双' : '单' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{ [1, 2, 3, 5, 7].includes(Number(qsOpenNumArr[index][0])) ? '质' : '合' }}{{ [1, 2, 3, 5, 7].includes(Number(qsOpenNumArr[index][1])) ? '质' : '合' }}{{ [1, 2, 3, 5, 7].includes(Number(qsOpenNumArr[index][2])) ? '质' : '合' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_green border-right">
              <i class="ball-noraml">{{ [0, 3, 6, 9].includes(Number(qsOpenNumArr[index][0])) ? '0' : [1, 4, 7].includes(Number(qsOpenNumArr[index][0])) ? '1' : '2' }}{{ [0, 3, 6, 9].includes(Number(qsOpenNumArr[index][1])) ? '0' : [1, 4, 7].includes(Number(qsOpenNumArr[index][1])) ? '1' : '2' }}{{ [0, 3, 6, 9].includes(Number(qsOpenNumArr[index][2])) ? '0' : [1, 4, 7].includes(Number(qsOpenNumArr[index][2])) ? '1' : '2' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="zusan(qsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ zusan(qsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="zuliu(qsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ zuliu(qsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="baozi(qsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ baozi(qsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{kuadu(qsOpenNumArr)[index]}}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_red border-right">
              <i class="ball-noraml">{{ hezhi(qsOpenNumArr)[index] }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai border-right">
              <i class="ball-noraml">{{ (hezhi(qsOpenNumArr)[index]).toString().slice(-1) }}</i>
            </td>
          </template>
          <template v-if="currPlay === 'zs'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{ Number(zsOpenNumArr[index][0]) >= 5 ? '大' : '小' }}{{ Number(zsOpenNumArr[index][1]) >= 5 ? '大' : '小' }}{{ Number(zsOpenNumArr[index][2]) >= 5 ? '大' : '小' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_green border-right">
              <i class="ball-noraml">{{ Number(zsOpenNumArr[index][0]) % 2 == 0 ? '双' : '单' }}{{ Number(zsOpenNumArr[index][1]) % 2 == 0 ? '双' : '单' }}{{ Number(zsOpenNumArr[index][2]) % 2 == 0 ? '双' : '单' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{ [1, 2, 3, 5, 7].includes(Number(zsOpenNumArr[index][0])) ? '质' : '合' }}{{ [1, 2, 3, 5, 7].includes(Number(zsOpenNumArr[index][1])) ? '质' : '合' }}{{ [1, 2, 3, 5, 7].includes(Number(zsOpenNumArr[index][2])) ? '质' : '合' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_green border-right">
              <i class="ball-noraml">{{ [0, 3, 6, 9].includes(Number(zsOpenNumArr[index][0])) ? '0' : [1, 4, 7].includes(Number(zsOpenNumArr[index][0])) ? '1' : '2' }}{{ [0, 3, 6, 9].includes(Number(zsOpenNumArr[index][1])) ? '0' : [1, 4, 7].includes(Number(zsOpenNumArr[index][1])) ? '1' : '2' }}{{ [0, 3, 6, 9].includes(Number(zsOpenNumArr[index][2])) ? '0' : [1, 4, 7].includes(Number(zsOpenNumArr[index][2])) ? '1' : '2' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="zusan(zsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ zusan(zsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="zuliu(zsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ zuliu(zsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="baozi(zsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ baozi(zsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{kuadu(zsOpenNumArr)[index]}}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_red border-right">
              <i class="ball-noraml">{{ hezhi(zsOpenNumArr)[index] }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai border-right">
              <i class="ball-noraml">{{ (hezhi(zsOpenNumArr)[index]).toString().slice(-1) }}</i>
            </td>
          </template>
          <template v-if="currPlay === 'hs'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{ Number(hsOpenNumArr[index][0]) >= 5 ? '大' : '小' }}{{ Number(hsOpenNumArr[index][1]) >= 5 ? '大' : '小' }}{{ Number(hsOpenNumArr[index][2]) >= 5 ? '大' : '小' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_green border-right">
              <i class="ball-noraml">{{ Number(hsOpenNumArr[index][0]) % 2 == 0 ? '双' : '单' }}{{ Number(hsOpenNumArr[index][1]) % 2 == 0 ? '双' : '单' }}{{ Number(hsOpenNumArr[index][2]) % 2 == 0 ? '双' : '单' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{ [1, 2, 3, 5, 7].includes(Number(hsOpenNumArr[index][0])) ? '质' : '合' }}{{ [1, 2, 3, 5, 7].includes(Number(hsOpenNumArr[index][1])) ? '质' : '合' }}{{ [1, 2, 3, 5, 7].includes(Number(hsOpenNumArr[index][2])) ? '质' : '合' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_green border-right">
              <i class="ball-noraml">{{ [0, 3, 6, 9].includes(Number(hsOpenNumArr[index][0])) ? '0' : [1, 4, 7].includes(Number(hsOpenNumArr[index][0])) ? '1' : '2' }}{{ [0, 3, 6, 9].includes(Number(hsOpenNumArr[index][1])) ? '0' : [1, 4, 7].includes(Number(hsOpenNumArr[index][1])) ? '1' : '2' }}{{ [0, 3, 6, 9].includes(Number(hsOpenNumArr[index][2])) ? '0' : [1, 4, 7].includes(Number(hsOpenNumArr[index][2])) ? '1' : '2' }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="zusan(hsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ zusan(hsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="zuliu(hsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ zuliu(hsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="zusan border-right">
              <i class="ball-noraml duizi" v-if="baozi(hsOpenNumArr)[index] === 'A'"></i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ baozi(hsOpenNumArr)[index] }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_blue border-right">
              <i class="ball-noraml">{{kuadu(hsOpenNumArr)[index]}}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai bgc_red border-right">
              <i class="ball-noraml">{{ hezhi(hsOpenNumArr)[index] }}</i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="dxxintai border-right">
              <i class="ball-noraml">{{ (hezhi(hsOpenNumArr)[index]).toString().slice(-1) }}</i>
            </td>
          </template>
         </tr>
        </template>
        <template v-if="currPlay === 'qe' || currPlay === 'he'">
         <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 号码走势 -->
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList" v-if="currPlay === 'qe'&&entindex < 2">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none" :key="entindex + 'left'"></td>
            <td class="df-trendchart-ssc-tdsize" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList" v-if="currPlay === 'he'&&entindex > 2">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none" :key="entindex + 'left'"></td>
            <td class="df-trendchart-ssc-tdsize" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'qe'">
          <!-- 对子 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="baozi border-right">
            <i class="ball-noraml duizi" v-if="duizi(qeOpenNumArr)[index] === 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ duizi(qeOpenNumArr)[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <!-- 号码分布 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in qeOpenNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 跨度走势 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="openNo-kuadu-td" v-for="(item, qekdindex) in qeKuaduTableList[index]" :key="qekdindex + 'erkd'">
            <i class="ball-noraml openNo-kuadu" v-if="item === 'A'">{{ lotteryNumbHead[qekdindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ item }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 和值 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="">
            <i class="ball-noraml ">{{ erHezhi(qeOpenNumArr)[index] }}</i>
          </td>
          </template>
          <template v-if="currPlay === 'he'">
          <!-- 对子 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="baozi border-right">
            <i class="ball-noraml duizi" v-if="duizi(heOpenNumArr)[index] === 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ duizi(heOpenNumArr)[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <!-- 号码分布 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in heOpenNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 跨度走势 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="openNo-kuadu-td" v-for="(item, qekdindex) in heKuaduTableList[index]" :key="qekdindex + 'erkd'">
            <i class="ball-noraml openNo-kuadu" v-if="item === 'A'">{{ lotteryNumbHead[qekdindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ item }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 和值 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="">
            <i class="ball-noraml ">{{ erHezhi(heOpenNumArr)[index] }}</i>
          </td>
          </template>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
         </tr>
        </template>
      </tbody>
      <tfoot v-show="statisticalShow" v-if="lotteryTrendList&&lotteryTrendList.length > 0">
        <template v-if="currPlay === 'wx'">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, sindex) in openNumStatisticaList.countArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in openNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in openNumStatisticaList.maxMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in openNumStatisticaList.maxContinuity" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        </template>
        <template v-if="currPlay === 'wxzh'">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumStatisticaList.countArr">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="kindex + 'kdcount'" v-for="(count, kindex) in kuaduStatisticaList.countArr">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="dxbindex + 'dxbcount'" v-for="(count, dxbindex) in dxbStatisticaList.countArr">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="dsbindex + 'dsbcount'" v-for="(count, dsbindex) in dsbStatisticaList.countArr">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="zhbindex + 'zhbcount'" v-for="(count, zhbindex) in zhbStatisticaList.countArr">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom">
            <i class="ball-noraml"></i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in openNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="ksindex + 'kdam'" v-for="(averageMiss, ksindex) in kuaduStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="dxbamindex + 'dxbam'" v-for="(averageMiss, dxbamindex) in dxbStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="dsbamindex + 'dsbam'" v-for="(averageMiss, dsbamindex) in dsbStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="zhbamindex + 'zhbam'" v-for="(averageMiss, zhbamindex) in zhbStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom">
            <i class="ball-noraml"></i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in openNumStatisticaList.maxMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="mindex + 'kdm'" v-for="(maxMiss, mindex) in kuaduStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="dxbmindex + 'dxbm'" v-for="(maxMiss, dxbmindex) in dxbStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="dsbmindex + 'dsbm'" v-for="(maxMiss, dsbmindex) in dsbStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="zhbmindex + 'zhbm'" v-for="(maxMiss, zhbmindex) in zhbStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom">
            <i class="ball-noraml"></i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in openNumStatisticaList.maxContinuity" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="mcindex + 'kdmc'" v-for="(maxContinuity, mcindex) in kuaduStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="dxbmcndex + 'dxbmc'" v-for="(maxContinuity, dxbmcndex) in dxbStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="dsbmcndex + 'dsbmc'" v-for="(maxContinuity, dsbmcndex) in dsbStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td colspan="2" class="border-bottom" :key="zhbmcndex + 'zhbmc'" v-for="(maxContinuity, zhbmcndex) in zhbStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom">
            <i class="ball-noraml"></i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
        </tr>
        </template>
        <template v-if="currPlay === 'sx'">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 0">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, sindex) in sxOpenNumStatisticaList.countArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 0">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in sxOpenNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 0">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in sxOpenNumStatisticaList.maxMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 0">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in sxOpenNumStatisticaList.maxContinuity" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        </template>
        <template v-if="currPlay === 'qs'">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index < 3">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, sindex) in qsOpenNumStatisticaList.countArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( zusan(qsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( zuliu(qsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( baozi(qsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index < 3">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in qsOpenNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( zusan(qsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( zuliu(qsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( baozi(qsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index < 3">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in qsOpenNumStatisticaList.maxMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( zusan(qsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( zuliu(qsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( baozi(qsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index < 3">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in qsOpenNumStatisticaList.maxContinuity" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( zusan(qsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( zuliu(qsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( baozi(qsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        </template>
        <template v-if="currPlay === 'zs'">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 0 && index < 4">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, sindex) in zsOpenNumStatisticaList.countArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( zusan(zsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( zuliu(zsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( baozi(zsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 0 && index < 4">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in zsOpenNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( zusan(zsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( zuliu(zsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( baozi(zsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 0 && index < 4">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in zsOpenNumStatisticaList.maxMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( zusan(zsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( zuliu(zsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( baozi(zsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 0 && index < 4">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in zsOpenNumStatisticaList.maxContinuity" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( zusan(zsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( zuliu(zsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( baozi(zsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        </template>
        <template v-if="currPlay === 'hs'">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 1">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, sindex) in hsOpenNumStatisticaList.countArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( zusan(hsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( zuliu(hsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( baozi(hsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 1">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in hsOpenNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( zusan(hsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( zuliu(hsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( baozi(hsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 1">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in hsOpenNumStatisticaList.maxMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( zusan(hsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( zuliu(hsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( baozi(hsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 1">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in hsOpenNumStatisticaList.maxContinuity" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="i in 4">
          <td :key="i + 'leftl'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerm'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'rightn'" class="ball-none border-right border-bottom"></td>
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( zusan(hsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( zuliu(hsOpenNumArr) ,'A') }}</i>
          </td>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( baozi(hsOpenNumArr) ,'A') }}</i>
          </td>
          <template v-for="i in 3">
          <td :key="i + 'leftq'" class="ball-none border-bottom"></td> 
          <td :key="i + 'centerw'" colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td :key="i + 'righte'" class="ball-none border-right border-bottom"></td>
          </template>
        </tr>
        </template>
        <template v-if="currPlay === 'qe'">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index < 2">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( duizi(qeOpenNumArr) ,'A') }}</i>
          </td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, sindex) in qeOpenNumStatisticaList.countArr" :key="sindex + 'count'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, qekindex) in qeKuaduStatisticaList.countArr" :key="qekindex + 'qekount'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td colspan="1" class="border-bottom dxxintai"><i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index < 2">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( duizi(qeOpenNumArr) ,'A') }}</i>
          </td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in qeOpenNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, qekamindex) in qeKuaduStatisticaList.averageMissArr" :key="qekamindex + 'qekaverageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td colspan="1" class="border-bottom dxxintai"><i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index < 2">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( duizi(qeOpenNumArr) ,'A') }}</i>
          </td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in qeOpenNumStatisticaList.maxMissArr" :key="sindex + 'maxMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, qekmindex) in qeKuaduStatisticaList.maxMissArr" :key="qekmindex + 'qekmaxMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td colspan="1" class="border-bottom dxxintai"><i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index < 2">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( duizi(qeOpenNumArr) ,'A') }}</i>
          </td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in qeOpenNumStatisticaList.maxContinuity" :key="sindex + 'maxContinuity'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, qekmcindex) in qeKuaduStatisticaList.maxContinuity" :key="qekmcindex + 'qekmaxContinuity'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td colspan="1" class="border-bottom dxxintai"><i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        </template>
        <template v-if="currPlay === 'he'">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 2">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ counts( duizi(heOpenNumArr) ,'A') }}</i>
          </td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, sindex) in heOpenNumStatisticaList.countArr" :key="sindex + 'count'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, qekindex) in heKuaduStatisticaList.countArr" :key="qekindex + 'qekount'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td colspan="1" class="border-bottom dxxintai"><i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 2">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs( duizi(heOpenNumArr) ,'A') }}</i>
          </td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in heOpenNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, qekamindex) in heKuaduStatisticaList.averageMissArr" :key="qekamindex + 'qekaverageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td colspan="1" class="border-bottom dxxintai"><i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 2">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs( duizi(heOpenNumArr) ,'A') }}</i>
          </td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in heOpenNumStatisticaList.maxMissArr" :key="sindex + 'maxMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, qekmindex) in heKuaduStatisticaList.maxMissArr" :key="qekmindex + 'qekmaxMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td colspan="1" class="border-bottom dxxintai"><i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList" v-if="index > 2">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="zusan border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys( duizi(heOpenNumArr) ,'A') }}</i>
          </td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in heOpenNumStatisticaList.maxContinuity" :key="sindex + 'maxContinuity'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, qekmcindex) in heKuaduStatisticaList.maxContinuity" :key="qekmcindex + 'qekmaxContinuity'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td colspan="1" class="border-bottom dxxintai"><i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        </template>
      </tfoot>
    </table>
  </div>
</template>

<script>
import mix from "../../../mixins/trendChart.mixins.vue";
export default {
  name: 'SscChart',
  mixins: [mix],
  props: {
    currPlay: {
      type: [String],
      default: 'wx'
    }
  },
  computed: {
    // 五星号码跨度
    kuaduArr() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
        const max = Math.max(Number(numArr[0]), Number(numArr[1]), Number(numArr[2]), Number(numArr[3]), Number(numArr[4]))
        const min = Math.min(Number(numArr[0]), Number(numArr[1]), Number(numArr[2]), Number(numArr[3]), Number(numArr[4]))
        arr[index] = max - min
      })
      return arr
    },
    // 五星号码跨度趋势
    kuaduTableList() {
      return this.chartTotalList(this.lotteryNumbHead, this.kuaduArr)
    },
    // 五星号码跨度统计
    kuaduStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.kuaduTableList)
    },
    // 前二号码跨度
    qeKuaduArr() {
      let arr = []
      this.qeOpenNumArr.forEach((numArr, index) => {
        const max = Math.max(Number(numArr[0]), Number(numArr[1]))
        const min = Math.min(Number(numArr[0]), Number(numArr[1]))
        arr[index] = max - min
      })
      return arr
    },
    // 前二号码跨度趋势
    qeKuaduTableList() {
      return this.chartTotalList(this.lotteryNumbHead, this.qeKuaduArr)
    },
    // 前二号码跨度统计
    qeKuaduStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.qeKuaduTableList)
    },
    // 后二号码跨度
    heKuaduArr() {
      let arr = []
      this.heOpenNumArr.forEach((numArr, index) => {
        const max = Math.max(Number(numArr[0]), Number(numArr[1]))
        const min = Math.min(Number(numArr[0]), Number(numArr[1]))
        arr[index] = max - min
      })
      return arr
    },
    // 后二号码跨度趋势
    heKuaduTableList() {
      return this.chartTotalList(this.lotteryNumbHead, this.heKuaduArr)
    },
    // 后二号码跨度统计
    heKuaduStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.heKuaduTableList)
    },
    // 单双比趋势
    dsbTableList() {
      return this.chartTotalList(this.lotteryNumStatusHead, this.dsb)
    },
    // 单双比统计
    dsbStatisticaList() {
      return this.statistica(this.lotteryNumStatusHead,this.dsbTableList)
    },
    // 大小比
    dxb() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
        let da = 0
        let xiao = 0
        numArr.forEach(numStr => {
          if(parseInt(numStr) >= 5) {
            da += 1
          } else {
            xiao += 1
          }
        })
        arr[index] = `${da}:${xiao}`
      })
      return arr
    },
    // 大小比趋势
    dxbTableList() {
      return this.chartTotalList(this.lotteryNumStatusHead, this.dxb)
    },
    // 大小比统计
    dxbStatisticaList() {
      return this.statistica(this.lotteryNumStatusHead,this.dxbTableList)
    },
    // 质合比
    zhb() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
        let zhi = 0
        let he = 0
        numArr.forEach(numStr => {
          if([1, 2, 3, 5, 7].includes(Number(numStr))) {
            zhi += 1
          } else {
            he += 1
          }
        })
        arr[index] = `${zhi}:${he}`
      })
      return arr
    },
    // 质合比
    zhbTableList() {
      return this.chartTotalList(this.lotteryNumStatusHead, this.zhb)
    },
    // 质合比统计
    zhbStatisticaList() {
      return this.statistica(this.lotteryNumStatusHead,this.zhbTableList)
    },
    // 四星只取后面四个开奖结果
    sxOpenNumArr() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
         let a = JSON.parse(JSON.stringify(numArr))
         a.shift()
         arr[index] = a
      })
      return arr
    },
    sxOpenNumTableList() {
      return this.chartList(this.sxOpenNumArr)
    },
    // 四星号码分布统计
    sxOpenNumStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.sxOpenNumTableList)
    },
    // 前三
    qsOpenNumArr() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
          let a = JSON.parse(JSON.stringify(numArr))
          a.pop()
          a.pop()
         arr[index] = a
      })
      return arr
    },
    qsOpenNumTableList() {
      return this.chartList(this.qsOpenNumArr)
    },
    // 前三号码分布统计
    qsOpenNumStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.qsOpenNumTableList)
    },
    // 中三
    zsOpenNumArr() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
          let a = JSON.parse(JSON.stringify(numArr))
          a.pop()
          a.shift()
         arr[index] = a
      })
      return arr
    },
    zsOpenNumTableList() {
      return this.chartList(this.zsOpenNumArr)
    },
    // 中三号码分布统计
    zsOpenNumStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.zsOpenNumTableList)
    },
    // 后三
    hsOpenNumArr() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
          let a = JSON.parse(JSON.stringify(numArr))
          a.shift()
          a.shift()
         arr[index] = a
      })
      return arr
    },
    hsOpenNumTableList() {
      return this.chartList(this.hsOpenNumArr)
    },
    // 后三号码分布统计
    hsOpenNumStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.hsOpenNumTableList)
    },
    // 前二
    qeOpenNumArr() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
          let a = JSON.parse(JSON.stringify(numArr))
          a.pop()
          a.pop()
          a.pop()
         arr[index] = a
      })
      return arr
    },
    qeOpenNumTableList() {
      return this.chartList(this.qeOpenNumArr)
    },
    // 前二号码分布统计
    qeOpenNumStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.qeOpenNumTableList)
    },
    // 后二
    heOpenNumArr() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
          let a = JSON.parse(JSON.stringify(numArr))
          a.shift()
          a.shift()
          a.shift()
         arr[index] = a
      })
      return arr
    },
    heOpenNumTableList() {
      return this.chartList(this.heOpenNumArr)
    },
    // 后二号码分布统计
    heOpenNumStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.heOpenNumTableList)
    },
  },
  mounted() {
    this.$nextTick((e) => {
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawArraySScCanvas();
        }, 0);
      });
    });
  },
  updated() {
    this.$nextTick((e) => {
      console.log('时时彩更新绘图');
      if(this.currPlay == 'wxzh') {
        return;
      }
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawArraySScCanvas();
        }, 0);
      });
    });
  },
  methods: {
    drawArraySScCanvas() {
      let list
      switch(this.currPlay) {
        case 'wx':
          list = this.getArrayChartCoordinate(this.openNumSperateTrendList);
          break;
        case 'wxzh':
          break;
        case 'sx':
          list = this.getArrayChartCoordinate(this.openNumSperateTrendList.slice(1));
          break;
        case 'qs':
          list = this.getArrayChartCoordinate(this.openNumSperateTrendList.slice(0,3));
          break;
        case 'zs':
          list = this.getArrayChartCoordinate(this.openNumSperateTrendList.slice(1,4));
          break;
        case 'hs':
          list = this.getArrayChartCoordinate(this.openNumSperateTrendList.slice(2));
          break;
        case 'qe':
          list = this.getArrayChartCoordinate(this.openNumSperateTrendList.slice(0,2));
          break;
        case 'he':
          list = this.getArrayChartCoordinate(this.openNumSperateTrendList.slice(-2));
          break;
        default:
          break;
      }
        if(!list) {
          return;
        }
        const ctx = this.$refs.trendCanvas.getContext("2d");
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        list.forEach((coordinateList, index) => {
          ctx.beginPath();
          ctx.lineWidth = 2;
          ctx.strokeStyle = "#f53f00";
          for (let i = 0, len = coordinateList.length; i + 1 < len; i++) {
            ctx.moveTo(coordinateList[i][0], coordinateList[i][1]);
            ctx.lineTo(coordinateList[i + 1][0], coordinateList[i + 1][1]);
          }
          ctx.stroke();
        });
    },
    getArrayChartCoordinate(Coordinate) {
        if (!this.$refs.drawnumbHead) return [];
        let chartCoordinate = [];

        Coordinate.forEach((trendList, trendIndex) => {
          //获取坐标系
          let len = trendList.length;
          if (len == 0) return [];

          //先获取表格左边不需要折线部分的宽度
          let dwidth = this.$refs.drawnumbHead.offsetWidth;
          let pwidth = this.$refs.periodsHead.offsetWidth;
          //左边总宽度
          let leftCountWidth = dwidth + pwidth;
          //上边总高度
          let topCountWidth = this.$refs.Head.offsetHeight; // 上面总高度
          let rectWidth = 0
          // 四星大格子宽度
          let sxRectWidth1 = 0
          let sxRectWidth2 = 0
          let sxRectWidth3 = 0
          if(this.currPlay === 'sx') {
            sxRectWidth1 = this.$refs.sxRectWidth1.offsetWidth
            sxRectWidth2 = this.$refs.sxRectWidth2.offsetWidth
            sxRectWidth3 = this.$refs.sxRectWidth3.offsetWidth
          } else {
            // 大格子宽度
            rectWidth = this.$refs.rectWidth.offsetWidth
          }
          //表格td宽度 表格td高度
          if(!document.getElementById("smallRect")) {
            return;
          }
          const tdWidth = document.getElementById("smallRect").offsetWidth;
          const tdHeight = document.getElementById("smallRect").offsetHeight;
          
          let list = [];

          if(this.currPlay === 'sx') {
            console.log('计算四星')
            for (let i = 0; i < len; i++) {
              let numb = Number(this.lotteryNumbHead[trendList[i].indexOf("A")]);
              let index = this.lotteryNumbHead.indexOf(numb);
              let x
              if(trendIndex === 0) {
                x = leftCountWidth + 5 + (tdWidth * index + ( tdWidth / 2))
              }
              if(trendIndex === 1) {
                x = leftCountWidth + 5 + sxRectWidth1 + (tdWidth * index + ( tdWidth / 2))
              }
              if(trendIndex === 2) {
                x = leftCountWidth + 5 + sxRectWidth1 + sxRectWidth2 + (tdWidth * index + ( tdWidth / 2))
              }
              if(trendIndex === 3) {
                x = leftCountWidth + 5 + sxRectWidth1 + sxRectWidth2 + sxRectWidth3 + (tdWidth * index + ( tdWidth / 2))
              }
              let y = topCountWidth + (tdHeight * i + tdHeight / 2);
              list.push([x, y]);
            }
          } else {
            for (let i = 0; i < len; i++) {
              let numb = Number(this.lotteryNumbHead[trendList[i].indexOf("A")]);
              let index = this.lotteryNumbHead.indexOf(numb);
              let x = leftCountWidth + 5 + (rectWidth * trendIndex) + (tdWidth * index + ( tdWidth / 2))
              let y = topCountWidth + (tdHeight * i + tdHeight / 2);
              list.push([x, y]);
            }
          }
          chartCoordinate.push(list);
        });

        return chartCoordinate;
    },
    reverseArray(arr) {
      const originArr = JSON.parse(JSON.stringify(arr))
      return originArr.reverse()
    },
    // 对子
    duizi(targetArr) {
      let arr = []
      let i = 1
      this.reverseArray(targetArr).forEach((numArr, index) => {
        arr.push(i++)
        if((numArr[0] === numArr[1])) {
           arr[index] = 'A'
           i = 1
         }
      })
      return arr.reverse()
    },
    // 组三
    zusan(targetArr) {
      let arr = []
      let i = 1
      this.reverseArray(targetArr).forEach((numArr, index) => {
        arr.push(i++)
        if(
          (numArr[0] === numArr[1] && numArr[0] !== numArr[2])
          || (numArr[0] === numArr[2] && numArr[0] !== numArr[1])
          || (numArr[1] === numArr[2] && numArr[0] !== numArr[1])
        ) {
           arr[index] = 'A'
           i = 1
         }
      })
      return arr.reverse()
    },
    // 组六
    zuliu(targetArr) {
      let arr = []
      let i = 1
      this.reverseArray(targetArr).forEach((numArr, index) => {
        arr.push(i++)
        if(
          (numArr[0] !== numArr[1])
          && (numArr[0] !== numArr[2])
          && (numArr[1] !== numArr[2])
        ) {
           arr[index] = 'A'
           i = 1
         }
      })
      return arr.reverse()
    },
    // 豹子
    baozi(targetArr) {
      let arr = []
      let i = 1
      this.reverseArray(targetArr).forEach((numArr, index) => {
        arr.push(i++)
        if(
          (numArr[0] === numArr[1])
          && (numArr[0] === numArr[2])
          && (numArr[1] === numArr[2])
        ) {
           arr[index] = 'A'
           i = 1
         }
      })
      return arr.reverse()
    },
    // 跨度
    kuadu(targetArr) {
      let arr = []
      targetArr.forEach((numArr, index) => {
        const max = Math.max(Number(numArr[0]), Number(numArr[1]), Number(numArr[2]))
        const min = Math.min(Number(numArr[0]), Number(numArr[1]), Number(numArr[2]))
        arr[index] = max - min
      })
      return arr
    },
    // 直选和值
    hezhi(targetArr) {
      let arr = []
      targetArr.forEach((numArr, index) => {
        arr[index] = Number(numArr[0]) + Number(numArr[1]) + Number(numArr[2])
      })
      return arr
    },
    erHezhi(targetArr) {
      let arr = []
      targetArr.forEach((numArr, index) => {
        arr[index] = Number(numArr[0]) + Number(numArr[1])
      })
      return arr
    }
  }
}
</script>

<style>
@media screen and (max-width: 1920px) {
  .df-trendchart-ssc-tdsize {
    width:27px;
    height:35px;
  }
}
@media screen and (max-width: 1370px) {
  .df-trendchart-ssc-tdsize {
    width:16px;
    height: 35px;
  }
}
@media screen and (max-width: 1300px) {
  .df-trendchart-ssc-tdsize {
    width:16px;
    height: 35px;
  }
}
</style>